module.exports = __webpack_public_path__ + "assets/img/fd7e2801a0839e6e3b09061f59e26a87.png";